import moment from 'moment';
import { STATUS_LABELS } from './constants';

/** Chaves legíveis usadas no pivot (drag-and-drop). */
export const PIVOT_FIELD = {
  DIGITADO_EM: 'Digitado em',
  DIGITADOR: 'Digitador',
  INSPETOR: 'Inspetor',
  TIPO_SERVICO: 'Tipo Serviço',
  SUBTIPO: 'Subtipo',
  CLIENTE: 'Cliente',
  NSIR: 'NSIR',
  STATUS: 'Status',
  MALHA: 'Malha',
  GERENCIA: 'Gerência',
  POLO: 'Polo',
  SUBESTACAO: 'Subestação',
  ALIMENTADOR: 'Alimentador',
  TOTAL_DIGITADOS: 'Total Digitados',
  ULTIMA_DIGITACAO: 'Última Digitação',
};

export const DEFAULT_PIVOT_STATE = {
  rows: [PIVOT_FIELD.MALHA],
  cols: [PIVOT_FIELD.STATUS],
  vals: [PIVOT_FIELD.TOTAL_DIGITADOS],
  aggregatorName: 'Sum',
};

const formatDate = (value) => {
  if (value == null) return '—';
  const n = Number(value);
  return moment(!Number.isNaN(n) && n > 0 ? n : value).format('DD/MM/YYYY');
};

const formatDateTime = (value) => {
  if (value == null) return '—';
  const n = Number(value);
  return moment(!Number.isNaN(n) && n > 0 ? n : value).format('DD/MM/YYYY HH:mm');
};

/** Mapeia linhas da API para objetos flat consumidos pelo react-pivottable. */
export const mapRowsForPivot = (rows) =>
  (rows || []).map((row) => ({
    [PIVOT_FIELD.DIGITADO_EM]: formatDate(row.dataDigitacao),
    [PIVOT_FIELD.DIGITADOR]: row.digitadorNome || '—',
    [PIVOT_FIELD.INSPETOR]: row.inspetorNome || '—',
    [PIVOT_FIELD.TIPO_SERVICO]: row.tipoServicoNome || '—',
    [PIVOT_FIELD.SUBTIPO]: row.subtipoNome || '—',
    [PIVOT_FIELD.CLIENTE]: row.clienteNome || '—',
    [PIVOT_FIELD.NSIR]: row.nsirCodigo || '—',
    [PIVOT_FIELD.STATUS]: STATUS_LABELS[row.status] || row.status || '—',
    [PIVOT_FIELD.MALHA]: row.malhaNome || '—',
    [PIVOT_FIELD.GERENCIA]: row.gerenciaNome || '—',
    [PIVOT_FIELD.POLO]: row.poloNome || '—',
    [PIVOT_FIELD.SUBESTACAO]: row.subestacaoNome || '—',
    [PIVOT_FIELD.ALIMENTADOR]: row.alimentadorNome || '—',
    [PIVOT_FIELD.TOTAL_DIGITADOS]: Number(row.totalDigitados) || 0,
    [PIVOT_FIELD.ULTIMA_DIGITACAO]: formatDateTime(row.ultimaDigitacao),
  }));
